import VCard from './Card.vue';
import VColorPicker from './ColorPicker.vue';
import VDropdown from './Dropdown.vue';
import VDropdownMenu from './DropdownMenu.vue';
import VList from './List.vue';
import VPaginate from './Paginate.vue';
import VStickyColumn from './StickyColumn.vue';
import VTable from './Table.vue';
import VTabs from './Tabs.vue';
import VTabsRouter from './TabsRouter.vue';
import VUploader from './Uploader.vue';

const components = {
  VCard,
  VColorPicker,
  VDropdown,
  VDropdownMenu,
  VList,
  VPaginate,
  VStickyColumn,
  VTable,
  VTabs,
  VTabsRouter,
  VUploader,
};

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => {
      Vue.component(name, components[name]);
    });
  },
};

export {
  VCard,
  VColorPicker,
  VDropdown,
  VDropdownMenu,
  VList,
  VPaginate,
  VStickyColumn,
  VTable,
  VTabs,
  VTabsRouter,
  VUploader,
};
